export { default as Title } from "./title.component";
